import { ManureCategory } from './manure-category.model';

export enum ManureType {
  drijfmestMix = 'DrijfmestMix',
  fokzeugenMest = 'FokzeugenMest',
  roseMest = 'RoseMest',
  rundveedrijfmest = 'Rundveedrijfmest',
  varkensdrijfmest = 'Varkensdrijfmest',
  witvleesmest = 'Witvleesmest',
  digestaat = 'Digestaat',
  digestaatRose = 'DigestaatRose',
  digestaatVarkens = 'DigestaatVarkens',
  dikkeFractie = 'DikkeFractie',
  stapelbareMest = 'StapelbareMest',
  bandenmest = 'Bandenmest',
  eendenmest = 'Eendenmest',
  geitenmest = 'Geitenmest',
  rundveemestGescheiden = 'RundveemestGescheiden',
  kalkoenmest = 'Kalkoenmest',
  moederdierenmest = 'Moederdierenmest',
  paardenmest = 'Paardenmest',
  rundveemest = 'Rundveemest',
  varkensmestStrobasis = 'VarkensmestStrobasis',
  vleeskuiken = 'Vleeskuiken',
  digestaatPlantaardig = 'DigestaatPlantaardig',
  spuiwater = 'Spuiwater',
  bioDigestaat = 'BioDigestaat',
  bioGeitenmest = 'BioGeitenmest',
  bioKippenmest = 'BioKippenmest',
  bioRundveedrijfmest = 'BioRundveedrijfmest',
  bioRundveemest = 'BioRundveemest',
  bioSchapenmest = 'BioSchapenmest',
  bioVarkensdrijfmest = 'BioVarkensdrijfmest',
  bioVarkensmest = 'BioVarkensmest',
  kippenDeeppitstalKanalenstal = 'KippenDeeppitstalKanalenstal',
  kippenMestband = 'KippenMestband',
  kippenMestbandNadroog = 'KippenMestbandNadroog',
}

export const manureTypeOptions: {
  [T in ManureCategory]: ManureType[];
} = {
  [ManureCategory.slurry]: [
    ManureType.drijfmestMix,
    ManureType.fokzeugenMest,
    ManureType.roseMest,
    ManureType.rundveedrijfmest,
    ManureType.varkensdrijfmest,
    ManureType.witvleesmest,
    ManureType.digestaat,
    ManureType.digestaatRose,
    ManureType.digestaatVarkens,
    ManureType.dikkeFractie,
    ManureType.stapelbareMest,
  ],
  [ManureCategory.solid]: [
    ManureType.bandenmest,
    ManureType.eendenmest,
    ManureType.geitenmest,
    ManureType.rundveemestGescheiden,
    ManureType.kalkoenmest,
    ManureType.moederdierenmest,
    ManureType.paardenmest,
    ManureType.rundveemest,
    ManureType.varkensmestStrobasis,
    ManureType.vleeskuiken,
    ManureType.kippenDeeppitstalKanalenstal,
    ManureType.kippenMestband,
    ManureType.kippenMestbandNadroog,
  ],
  [ManureCategory.biological]: [
    ManureType.bioDigestaat,
    ManureType.bioGeitenmest,
    ManureType.bioKippenmest,
    ManureType.bioRundveedrijfmest,
    ManureType.bioRundveemest,
    ManureType.bioSchapenmest,
    ManureType.bioVarkensdrijfmest,
    ManureType.bioVarkensmest,
  ],
  [ManureCategory.other]: [ManureType.digestaatPlantaardig, ManureType.spuiwater],
};
